import moment from 'moment';
import { AccountData } from '../../api';

// Mirror of api/logic/pass_logic.py DEFAULT_PASS_CUSTOMER_CANCEL_HOURS_BEFORE.
const DEFAULT_PASS_CUSTOMER_CANCEL_HOURS_BEFORE = 24;

export const getPassCancelHoursBefore = (account: AccountData | undefined, orderPageId: string): number => {
  const orderPage = account?.experiences?.flatMap((e) => e.order_pages ?? []).find((op) => op.id === orderPageId);
  return orderPage?.pass_customer_cancel_hours_before ?? DEFAULT_PASS_CUSTOMER_CANCEL_HOURS_BEFORE;
};

export const isPassCancelAllowed = (hoursBefore: number, date: string, timeSeconds: number | undefined): boolean => {
  if (timeSeconds === undefined) return true;
  const sessionStart = moment(date).startOf('day').add(timeSeconds, 'seconds');
  const cutoff = sessionStart.clone().subtract(hoursBefore, 'hours');
  return moment().isBefore(cutoff);
};
